
<template>
  <div />
</template>

<script>
import localStorageSvc from "@/services/localStorage";
export default {
    created(){
        let siteID =   this.$route.params.siteid;
        let userID = atob( this.$route.params.uid );
        if(siteID=='' || userID == '')
            this.$router.push('/');
        localStorageSvc.setUser(userID);        
        window.location='/'+siteID;
    }   
}
</script>
 

